export const formatRuleName = (rule: string): string => {
  const name = rule.split(".");
  return name[name.length - 1];
};
